import { graphql, useStaticQuery } from 'gatsby'

export const useSwaggerLimitedRelease = () => {
  const { allLimitedReleaseJson } = useStaticQuery(
    graphql`
      query allLimitedReleaseJson {
        allLimitedReleaseJson {
          nodes {
            swagger
            info {
              description
              version
              title
              x_publicDocsPath
            }
            host
            basePath
            tags {
              name
              description
              operations {
                summary
                description
                operationId
                tags
                parameters {
                  in
                  name
                  required
                  schema {
                    title
                    description
                    type
                    properties {
                      title
                      description
                      type
                      properties {
                        account_id {
                          type
                          description
                          format
                          minLength
                          maxLength
                          pattern
                          properties {
                            account_id {
                              description
                              href
                              format
                              maxLength
                              minLength
                              name
                              parentName
                              pattern
                              type
                            }
                          }
                          parentName
                          _ref
                          name
                          link
                        }
                      }
                      parentName
                      type
                      description
                      readOnly
                      minLength
                      maxLength
                      pattern
                      name
                      required
                      _ref
                      link
                    }
                    description
                    name
                  }
                }
                responses {
                  _200 {
                    description
                    schema {
                      title
                      _ref
                    }
                  }
                  _400 {
                    description
                    schema {
                      _ref
                    }
                  }
                  _403 {
                    description
                    schema {
                      _ref
                    }
                  }
                  _422 {
                    description
                    schema {
                      _ref
                    }
                  }
                  _500 {
                    description
                    schema {
                      _ref
                    }
                  }
                }
                x_slo {
                  response_time_95th_percentile
                  error_rate
                }
                path
                method
                samples {
                  request
                  response
                }
                headerParameters {
                  name
                  in
                  type
                  description
                  required
                }
                sampleLocation
                responseDescription
                cleanedRequestBody {
                  requestBody_name
                  requestBody_content {
                    title
                    description
                    type
                    properties {
                      account_id {
                        type
                        description
                        format
                        minLength
                        maxLength
                        pattern
                        properties {
                          account_id {
                            description
                            href
                            format
                            maxLength
                            minLength
                            name
                            parentName
                            pattern
                            type
                          }
                        }
                        parentName
                        _ref
                        name
                        link
                      }
                    }
                    parentName
                    readOnly
                    _ref
                    name
                    link
                    required
                  }
                }
                cleanedResponse {
                  response_name
                  response_content {
                    title
                    description
                    type
                    properties {
                      id {
                        name
                        href
                        type
                        description
                        parentName
                        readOnly
                        required
                      }
                    }
                    parentName
                    readOnly
                    _ref
                    minLength
                    maxLength
                    pattern
                    name
                    defaultValue
                  }
                }
              }
              title
            }
            schemes
            produces
            consumes
            definitions {
              title
              name
              href
              type
              description
              properties {
                type
                description
                format
                minLength
                maxLength
                pattern
                properties {
                  account_id {
                    description
                    href
                    format
                    maxLength
                    minLength
                    name
                    parentName
                    pattern
                    type
                  }
                }
                parentName
                href
                name
              }
            }
            x_errors {
              details
              description
              information_link
            }
            _borg_metadata {
              timeFetched
              repository
              branch
              version
              visibility
            }
            namingOverrides {
              x_publicDocsPath
              x_navTitle
            }
          }
        }
      }
    `,
  )
  return allLimitedReleaseJson
}
